'use client'

import { useRouter } from 'next/compat/router'
import { styled } from 'styled-components'

import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import { GlobalHeaderWrapper } from '@/components/globalHeader'
import { HeaderAnalyticsProvider } from '@/components/globalHeader/HeaderAnalyticsProvider'
import { FeatureFlags } from '@/helpers/featureFlags'

import { shouldShowAccountBrowseNav } from './shouldShowAccountBrowseNav'

// The auction nav renders as a sibling of <header> and sizes itself from
// --headerPadding; without it the bar goes full-bleed.
const HeaderContainer = styled.div<{ $showAuctionNav: boolean }>`
  --headerPadding: 1.5rem;
  padding-bottom: ${({ $showAuctionNav }) => ($showAuctionNav ? '0.25rem' : '0')};
  position: relative;
  z-index: 25;
`

export const Header = () => {
  const browseNavEnabled = useFlag(FeatureFlags.ENABLE_ACCOUNT_PAGES_BROWSE_NAV)
  const router = useRouter()

  // null under the App Router; pathname is the route pattern, not a resolved URL.
  const showAuctionNav =
    browseNavEnabled && shouldShowAccountBrowseNav(router?.pathname)

  return (
    <HeaderAnalyticsProvider pathname={router?.pathname ?? null} hasHomeIntent>
      <HeaderContainer $showAuctionNav={showAuctionNav}>
        <GlobalHeaderWrapper
          variant="storefront"
          showAuctionNav={showAuctionNav}
        />
      </HeaderContainer>
    </HeaderAnalyticsProvider>
  )
}
